export default function ratingToEmoji(value) {
  if (value === 0) return '😁'
  if (value === 1) return '😕'
  if (value === 2) return '😩'
  return ''
}
